import React from 'react'
import { Link } from 'react-router-dom'
import Room from 'material-ui/svg-icons/action/group-work'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import { FormattedMessage } from 'react-intl'
import { guestMenuItemStyles } from './styles'
import { Helmet } from 'react-helmet'

(function () {
  var link = document.querySelector('link[rel*=\'icon\']') || document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = window.location.origin + '/img/faviconWebinar.ico'
  document.getElementsByTagName('head')[0].appendChild(link)
})()

const Navigation = (props) => (
  <div className='h-100 flex flex-column justify-between'>
    <Helmet>
      <title>{'FreshVoice Webinar'}</title>
    </Helmet>
    <div>
      <div>
        <Menu
          disableAutoFocus
          selectedMenuItemStyle={{
            backgroundColor: 'rgba(231, 235, 240, 0.2)',
            color: '#000000de'
          }}
          value={props.path}
          autoWidth={false}
          width='100%'
          listStyle={{width: '0.01%'}}
          style={{width: '100%'}}>
          <div>
            <MenuItem
              value={'/domain/create'}
              primaryText={<FormattedMessage id='DomainWebinarNavigation.create'/>}
              containerElement={<Link to={'/domain/create'}/>}
              leftIcon={<Room color={'#000000de'}/>}
              style={guestMenuItemStyles}
            />
            <MenuItem
              value={'/edit_news?type=webinar'}
              primaryText={<FormattedMessage id='DomainWebinarNavigation.news'/>}
              containerElement={<Link to={'/edit_news?type=webinar'}/>}
              leftIcon={<Room color={'#000000de'}/>}
              style={{guestMenuItemStyles, whiteSpace: 'normal', fontSize: '14px', lineHeight: '30px'}}
            />
            <MenuItem
              value={'/edit_news?type=sessions'}
              primaryText={<FormattedMessage id='DomainWebinarNavigation.dd_news'/>}
              containerElement={<Link to={'/edit_news?type=sessions'}/>}
              leftIcon={<Room color={'#000000de'}/>}
              style={guestMenuItemStyles}
            />
          </div>
        </Menu>
      </div>
    </div>
    <div>
    </div>
  </div>
)

export default Navigation



// WEBPACK FOOTER //
// ./src/layouts/Domain/Navigation.js